// Display-only: turn the backend's lockout_until (Python str(datetime)) into a local
// clock time, adding the date when the unlock is not today. Returns "" if unparsable.
export const formatLockUntil = (raw, lang) => {
  if (!raw) return "";
  const d = new Date(String(raw).replace(" ", "T").replace(/(\.\d{3})\d+/, "$1"));
  if (Number.isNaN(d.getTime())) return "";
  const sameDay = d.toDateString() === new Date().toDateString();
  const opts = sameDay ? { hour: "numeric", minute: "2-digit" } : { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" };
  try { return d.toLocaleString(lang || undefined, opts); } catch { return d.toLocaleString(undefined, opts); }
};
